import { Validator, ValidatorSchema } from '@libs/utilities/validator';


/**------------------------------------------------------
 * Constants
 */
export const NG_DEFAULT_IMAGE_COMPARISON_CONFIG: INgImageComparisonConfig = {
	sliderPosPct	: 50,
	preImageUrl		: '',
	postImageUrl	: '',
	gripLineWidth	: 1,
	gripLineColor	: 'lightgray',
	gripRingWidth	: 30,
	gripRingColor	: 'pink',
	minPosPct		: 0,
	maxPosPct		: 100
};


/**------------------------------------------------------
 * Interfaces
 */
export interface INgImageComparisonConfig {
	sliderPosPct	: number;
	preImageUrl		: string;
	postImageUrl	: string;
	gripLineWidth	: number;
	gripLineColor	: string;
	gripRingWidth	: number;
	gripRingColor	: string;
	minPosPct		: number;
	maxPosPct		: number;
}


/**------------------------------------------------------
 * Schema
 */
export class NgImageComparisonSchema implements ValidatorSchema<INgImageComparisonConfig> {
	sliderPosPct	= Validator.Number().inRange(-1, 101);
	preImageUrl		= Validator.String().isUrl();
	postImageUrl	= Validator.String().isUrl();
	gripLineWidth	= Validator.Number().isPositive();
	gripLineColor	= Validator.String().isNotEmpty();
	gripRingWidth	= Validator.Number().isPositive();
	gripRingColor	= Validator.String().isNotEmpty();
	minPosPct		= Validator.Number().inRange(-1, 101);
	maxPosPct		= Validator.Number().inRange(-1, 101);
}
